import { render, staticRenderFns } from "./AccountClassTickets.vue?vue&type=template&id=320fc5c8&scoped=true&"
import script from "./AccountClassTickets.vue?vue&type=script&lang=js&"
export * from "./AccountClassTickets.vue?vue&type=script&lang=js&"
import style0 from "./AccountClassTickets.vue?vue&type=style&index=0&id=320fc5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320fc5c8",
  null
  
)

export default component.exports